import { register } from "register-service-worker";

const unregisterLegacyServiceWorkers = async () => {
  if (!("serviceWorker" in navigator)) {
    return;
  }

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(
      registrations.map((registration) => registration.unregister()),
    );

    if ("caches" in window) {
      const cacheKeys = await window.caches.keys();
      await Promise.all(
        cacheKeys.map((cacheKey) => window.caches.delete(cacheKey)),
      );
    }
  } catch (error) {
    console.error("Error clearing service workers:", error);
  }
};

const isProduction = process.env.NODE_ENV === "production";
const isPwaEnabled = process.env.VUE_APP_ENABLE_PWA === "true";

if (isProduction && !isPwaEnabled) {
  unregisterLegacyServiceWorkers();
}

if (isProduction && isPwaEnabled) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      // console.log(
      //   'App is being served from cache by a service worker.\n' +
      //   'For more details, visit https://goo.gl/AFskqB'
      // )
    },
    registered() {
      // console.log('Service worker has been registered.')
    },
    cached() {
      // console.log('Content has been cached for offline use.')
    },
    updatefound() {
      // console.log('New content is downloading.')
    },
    updated(registration) {
      try {
        const waiting =
          registration && registration.waiting ? registration.waiting : null;
        const key =
          waiting && waiting.scriptURL
            ? waiting.scriptURL
            : `sw-updated-${Date.now()}-${Math.random().toString(16).slice(2)}`;
        window.dispatchEvent(
          new CustomEvent("pwa:update-available", {
            detail: { registration, key },
          }),
        );
      } catch (e) {
        // No-op: si el navegador no soporta CustomEvent o falla algo, no bloquear la app
      }
    },
    offline() {
      // Este sistema opera 100% online.
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
  });
}
